import { Gradient } from 'types'
import SelectList, { SelectListProps } from '../../select-list'
import { PortalTooltip, useTooltip } from '../../tooltip'
import { TooltipProps } from '../../tooltip/hooks/use-tooltip'
import { Button } from './style'

type Props = {
    activeIndex?: number
    backgroundColor: string
    className?: string
    controlColor?: string
    controlId: string
    gradient?: Gradient
    options: string[]
    selectListOptions?: Partial<SelectListProps>
    tooltipOptions?: Partial<TooltipProps>
    onChange: (index: number) => void
}

const SegmentedControlMenu = ({
    activeIndex,
    backgroundColor,
    className,
    controlColor,
    controlId,
    options,
    selectListOptions = {},
    tooltipOptions = {},
    onChange,
}: Props) => {
    const { isOpen, listeners } = useTooltip({
        color: backgroundColor,
        direction: 'up',
        id: `${controlId}-menu`,
        ...tooltipOptions,
    })

    return (
        <>
            <Button className={className} color={backgroundColor} icon="ellipsis" {...listeners} />
            <PortalTooltip isOpen={isOpen}>
                <SelectList
                    iconColor={controlColor}
                    {...selectListOptions}
                    defaultIndex={activeIndex}
                    options={options}
                    onChange={onChange}
                />
            </PortalTooltip>
        </>
    )
}

export default SegmentedControlMenu
